import clsx from 'clsx';
import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { ModalContent, Modal as MuiModal } from 'atoms/Modal';
import { DialogProps } from 'modules/mui/types';
import styles from './styles.module.css';

export const Modal: FC<
  DialogProps & { customClasses?: { header?: string; closeIcon?: string } }
> = ({ children, onClose, customClasses, ...props }) => {
  return (
    <MuiModal
      onClose={(event, reason) => {
        if (reason == 'backdropClick' && onClose) {
          onClose(event, reason);
        }
      }}
      {...props}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      classes={{
        ...props.classes,
        paper: clsx(styles.wrapper, props.classes?.paper),
        container: clsx(styles.container, props.classes?.container),
      }}
    >
      <div
        className={clsx(styles.header, customClasses?.header)}
        id="scroll-dialog-title"
      >
        <Icon
          type={IconType.close}
          className={clsx(styles.close, customClasses?.closeIcon)}
          onClick={onClose as () => void}
        />
      </div>
      <ModalContent
        id="scroll-dialog-description"
        classes={{ root: styles.content }}
      >
        {children}
      </ModalContent>
    </MuiModal>
  );
};
